import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import Definition from './_Definition';

const DefinitionListCollection = ({ listCollectionData }) => (
  <ul className='ul-table-child'>
    {listCollectionData.map(listData => (
      <li key={uuidv4()}>
        <dl>
          {
            listData.map(listItemData => (
              <div className='definition-wrapper' key={uuidv4()}>
                <dt>
                  <div className='overflow-limiter'>
                    {listItemData.columnHeadingContent}
                  </div>
                </dt>
                <Definition listItemData={listItemData} />
              </div>
            ))}
        </dl>
      </li>
    ))}
  </ul>
);

export default DefinitionListCollection;